<div class="quote-course-details__info">
  <lx-quote-course-details-label>
    <ng-content select="[label]"></ng-content>
  </lx-quote-course-details-label>
  <lx-quote-course-details-name>
    <ng-content select="[name]"></ng-content>
  </lx-quote-course-details-name>
</div>
<lx-quote-cta-button *ngIf="showEditButton" icon="edit" (buttonClicked)="editButtonClicked.emit()"></lx-quote-cta-button>
